// extracted by mini-css-extract-plugin
export default {"closeBtn":"PopUpHeaderWithClose_closeBtn__Ncs5T","closeBtn__disabled":"PopUpHeaderWithClose_closeBtn__disabled__LCPzm","header":"PopUpHeaderWithClose_header__c7NmI"};